import { TicketAccess } from "../../../models/TicketAccess";
import {
  GET_AVAILABLE_EXERCISE,
  GET_DAYS_AVAILABLE_BYNAME,
  GET_DAYS_AVAILABLE_PASSIDS,
  GET_EXERCISE_BY_DATE_AND_NAME,
  GET_EXERCISE_BY_PASSID,
  GET_SCHEDULE_DETAILS,
  GET_TICKET_BY_EXERCISE,
  JOIN_TO_EXERCISE,
} from "../../../api/apiRoutes";
import { Assort } from "../../../models/Assort";
import { Exercise } from "../../../models/Exercise";
import { useState } from "react";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../utils/hooks/useFacility";
import { GET_EXERCISE_BY_DAY } from "../../../api/apiRoutes";
import { addDays, format } from "date-fns";
import { setTicketAccessFromExercise } from "../../../models/TicketAccess";
import { CalendarDaysAvailable } from "../../../models/CalendarDaysAvailable";
import { post } from "../../../api";
import { useSelector } from "react-redux";
import { State } from "../../../store";

export default function useCalendarSale() {
  const facilityIds = useFacility();
  const { get } = useApiRequest();
  const [exercise, setExercise] = useState<Exercise[]>([]);
  const [exerciseDetails, setExerciseDetails] = useState<Exercise>();
  const [exerciseAvailAble, setExerciseAvailAble] = useState<Exercise[]>([]);
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const [tickets, setTickets] = useState<Assort[]>([]);
  const [availableDays, setAvailableDays] = useState<CalendarDaysAvailable[]>([]);
  const [listaDat, setListaDat] = useState<any[]>([]);
  const [firstAvailableDate, setFirstAvailableDate] = useState<Date>(new Date());
  const [ticketLimit, setTicketLimit] = useState<number>(0);
  const [chooseTime, setChosenTime] = useState<number>(0);
  const [ticketAccess, setTicketAccess] = useState<TicketAccess>({} as TicketAccess);
  const [alertCalendar, setAlertCalendar] = useState<string>("");
  const [alerts, setAlerts] = useState<string>("");
  const userDataId = useSelector((state: State) => state.auth.userData.objectId);

  const joinToExercise = async (exerciseId: number, assigned: boolean, passId: string, onFinish: () => void) => {
    const { isError, errorTable } = await post(JOIN_TO_EXERCISE(facilityIds, passId), {
      exerciseIds: exerciseId,
      webUserIds: `0,${userDataId}`,
      assigned: assigned,
    });

    if (!isError) {
      onFinish();
    }
    if (isError) {
      setAlerts(errorTable[0]);
      setTimeout(() => {
        setAlerts("");
      }, 5000);
    }
  };

  const getExercisesByDay = async (date: Date) => {
    setSelectedDate(date);
    setExercise([]);
    setTicketAccess({} as TicketAccess);
    setTickets([]);
    const formattedDate = format(date, "yyyy-MM-dd");
    const { result, isError } = await get(GET_EXERCISE_BY_DAY(facilityIds, formattedDate));
    if (!isError) {
      setExercise(result);
    }
  };

  const getTicketsByExercise = async (Db:number, id: number, exercise: Exercise) => {
    const exerciseGroupIds = `${Db},${id}`;
    let ticketAccessTransform = setTicketAccessFromExercise(
      exercise.objectId,
      exercise.name.replace(/%/g, "%25"),
      exercise.startTime
    );
    setTicketAccess(ticketAccessTransform);
    const { result, isError } = await get(GET_TICKET_BY_EXERCISE(facilityIds, exerciseGroupIds));
    if (!isError) {
      setTickets(result);
      setTicketLimit(exercise.capacity - (exercise.reserved + exercise.prereservation));
      setChosenTime(exercise.startTime);
    }
  };
  // DO poierania zajęć dostępnych 120 w przód.
  const getExercisesAvailable = async () => {
    const formattedDateFrom = format(new Date(), "yyyy-MM-dd");
    const formattedDateTo = format(new Date(addDays(new Date(), 120)), "yyyy-MM-dd");

    const { result, isError } = await get(GET_AVAILABLE_EXERCISE(facilityIds, formattedDateFrom, formattedDateTo));
    if (!isError) {
      setExerciseAvailAble(result);
    }
  };

  // Pobieranie dni dla konkretnej nazwy zajęć
  const getDaysAvailableByName = async (name: string) => {
    const formattedDateFrom = format(new Date(), "yyyy-MM-dd");
    const formattedDateTo = format(new Date(addDays(new Date(), 120)), "yyyy-MM-dd");
    if (facilityIds !== null) {
      const { result, isError } = await get(
        GET_DAYS_AVAILABLE_BYNAME(facilityIds, formattedDateFrom, formattedDateTo, name.replace(/%/g, "%25"))
      );
      if (!isError) {
        setAvailableDays(result);
        const filterList = result.filter((item: any) => item.unavailable);
        setListaDat(filterList.map((item: any) => new Date(item.date)));
        const filterAvailableDateList = result.filter((item: any) => item.unavailable === false);
        if (filterAvailableDateList.length > 0) {
          const findedDate = filterAvailableDateList[0].date;
          setFirstAvailableDate(new Date(findedDate));
        }
      }
    }
  };

  //Pobieranie dni dla konkretnej grupy zajęciowej przy zmianie terminu
  const getDaysAvailableByPassId = async (passIds: number) => {
    const formattedDateFrom = format(new Date(), "yyyy-MM-dd");
    const formattedDateTo = format(new Date(addDays(new Date(), 120)), "yyyy-MM-dd");
    const { result, isError } = await get(
      GET_DAYS_AVAILABLE_PASSIDS(facilityIds, formattedDateFrom, formattedDateTo, "0," + passIds)
    );
    if (!isError) {
      setAvailableDays(result);
      const filterList = result.filter((item: any) => item.unavailable);
      setListaDat(filterList.map((item: any) => new Date(item.date)));
    }
  };

  const getExercisesByPassIds = async (date: Date, passIds: number) => {
    setSelectedDate(date);
    const formattedDateFrom = format(date, "yyyy-MM-dd");
    const { result, isError } = await get(
      GET_EXERCISE_BY_PASSID(facilityIds, formattedDateFrom, formattedDateFrom, "0," + passIds)
    );
    if (!isError) {
      setExercise(result);
    }
  };

  const getHoursAvaiableByName = async (date: Date, name: string) => {
    setSelectedDate(date);
    setExercise([]);
    setTicketAccess({} as TicketAccess);
    setTickets([]);
    const formattedDate = format(date, "yyyy-MM-dd");
    const { result, isError } = await get(
      GET_EXERCISE_BY_DATE_AND_NAME(facilityIds, formattedDate, name.replace(/%/g, "%25"))
    );
    if (!isError) {
      setExercise(result);

      if (result[0]) {
        let ticketAccessTransform = setTicketAccessFromExercise(
          result[0].objectDb,
          result[0].name,
          result[0].startTime
        );
        setTicketAccess(ticketAccessTransform);
      }
    }
  };

  const getAssignByTicket = async (passIds: number, exerciseIds: number) => {
    const params = {
      // assigned: ;
      webUserIds: `0,${userDataId}`,
      exerciseIds: exerciseIds,
      assigned: false,
    };
    const { isError, errorTable } = await post(JOIN_TO_EXERCISE(facilityIds, "0," + passIds), params);
    if (!isError) {
    }
    if (isError) {
      setTimeout(() => {
        setAlertCalendar(errorTable[0]);
      }, 200);
    }
  };

  const getDetailsAboutExercise = async (exerciseIds: number) => {
    if (userDataId) {
      const { result, isError } = await get(GET_SCHEDULE_DETAILS(facilityIds, `0,${exerciseIds}`, `0,+${userDataId}`));
      if (!isError) {
        setExerciseDetails(result);
        setTimeout(() => {
          setAlertCalendar("");
        }, 2000);
      }
    }
  };

  return {
    alerts,
    joinToExercise,
    exerciseDetails,
    getDetailsAboutExercise,
    alertCalendar,
    chooseTime,
    ticketLimit,
    getAssignByTicket,
    getExercisesByPassIds,
    getDaysAvailableByPassId,
    getHoursAvaiableByName,
    getDaysAvailableByName,
    availableDays,
    listaDat,
    getExercisesAvailable,
    exerciseAvailAble,
    getExercisesByDay,
    getTicketsByExercise,
    exercise,
    selectedDate,
    tickets,
    ticketAccess,
    firstAvailableDate,
  };
}
